export default {
    s: {
        x: 45,
        y: 214,
        shadowOffset: 10,
        // width: 280,
        maze: [
            {
                x0: 0,
                y0: 0,
                x1: 31,
                y1: 16,
            },
            {
                x0: 80,
                y0: 0,
                x1: 280,
                y1: 16,
            },
            {
                x0: 264,
                y0: 16,
                x1: 280,
                y1: 241,
            },
            {
                x0: 217,
                y0: 241,
                x1: 280,
                y1: 257,
            },
            {
                x0: 0,
                y0: 241,
                x1: 168,
                y1: 257,
            },
            {
                x0: 0,
                y0: 16,
                x1: 16,
                y1: 241,
            },

            {
                x0: 16,
                y0: 139,
                x1: 66,
                y1: 155,
            },
            {
                x0: 50,
                y0: 65,
                x1: 66,
                y1: 139,
            },
            {
                x0: 50,
                y0: 49,
                x1: 230,
                y1: 65,
            },
            {
                x0: 214,
                y0: 65,
                x1: 230,
                y1: 142,
            },

            {
                x0: 57,
                y0: 189,
                x1: 116,
                y1: 205,
            },
            {
                x0: 100,
                y0: 107,
                x1: 116,
                y1: 189,
            },
            {
                x0: 100,
                y0: 91,
                x1: 173,
                y1: 107,
            },
            {
                x0: 157,
                y0: 107,
                x1: 173,
                y1: 179,
            },
            {
                x0: 157,
                y0: 179,
                x1: 264,
                y1: 195,
            },
        ],
    },
    m: {
        x: 178,
        y: 365,
        // width: 427,
        shadowOffset: 15,
        maze: [
            {
                x0: 0,
                y0: 0,
                x1: 48,
                y1: 24,
            },
            {
                x0: 123,
                y0: 0,
                x1: 427,
                y1: 24,
            },
            {
                x0: 403,
                y0: 24,
                x1: 427,
                y1: 367,
            },
            {
                x0: 331,
                y0: 367,
                x1: 427,
                y1: 391,
            },
            {
                x0: 0,
                y0: 367,
                x1: 256,
                y1: 391,
            },
            {
                x0: 0,
                y0: 24,
                x1: 24,
                y1: 367,
            },

            {
                x0: 24,
                y0: 213,
                x1: 101,
                y1: 237,
            },
            {
                x0: 77,
                y0: 99,
                x1: 101,
                y1: 213,
            },
            {
                x0: 77,
                y0: 75,
                x1: 351,
                y1: 99,
            },
            {
                x0: 327,
                y0: 99,
                x1: 351,
                y1: 218,
            },

            {
                x0: 88,
                y0: 289,
                x1: 177,
                y1: 313,
            },
            {
                x0: 153,
                y0: 163,
                x1: 177,
                y1: 289,
            },
            {
                x0: 153,
                y0: 139,
                x1: 264,
                y1: 163,
            },
            {
                x0: 240,
                y0: 163,
                x1: 264,
                y1: 274,
            },
            {
                x0: 240,
                y0: 274,
                x1: 403,
                y1: 298,
            },
        ],
    },
    l: {
        x: 79,
        y: 184,
        finishData: {
            // sideSize: 996,
            width: 600,
            height: 548,
            top: -150,
            left: 600,
        },
        // width: 427,
        shadowOffset: 15,
        maze: [
            {
                x0: 0,
                y0: 0,
                x1: 47,
                y1: 24,
            },
            {
                x0: 121,
                y0: 0,
                x1: 422,
                y1: 24,
            },
            {
                x0: 397,
                y0: 24,
                x1: 422,
                y1: 362,
            },
            {
                x0: 326,
                y0: 362,
                x1: 422,
                y1: 386,
            },
            {
                x0: 0,
                y0: 362,
                x1: 254,
                y1: 386,
            },
            {
                x0: 0,
                y0: 24,
                x1: 25,
                y1: 362,
            },

            {
                x0: 25,
                y0: 210,
                x1: 99,
                y1: 234,
            },
            {
                x0: 74,
                y0: 98,
                x1: 99,
                y1: 210,
            },
            {
                x0: 74,
                y0: 74,
                x1: 346,
                y1: 98,
            },
            {
                x0: 321,
                y0: 98,
                x1: 346,
                y1: 215,
            },

            {
                x0: 86,
                y0: 286,
                x1: 176,
                y1: 310,
            },
            {
                x0: 151,
                y0: 161,
                x1: 176,
                y1: 286,
            },
            {
                x0: 151,
                y0: 137,
                x1: 260,
                y1: 161,
            },
            {
                x0: 235,
                y0: 161,
                x1: 260,
                y1: 270,
            },
            {
                x0: 235,
                y0: 270,
                x1: 397,
                y1: 294,
            },
        ],
    },
    xl: {
        x: 99,
        y: 222,
        // width: 528,
        finishData: {
            // sideSize: 1137,
            width: 807,
            height: 737,
            top: -247,
            left: 730,
            // top: 0,
            // left: 1200,
        },
        shadowOffset: 19,
        maze: [
            {
                x0: 0,
                y0: 0,
                x1: 59,
                y1: 30,
            },
            {
                x0: 152,
                y0: 0,
                x1: 528,
                y1: 30,
            },
            {
                x0: 498,
                y0: 30,
                x1: 528,
                y1: 455,
            },
            {
                x0: 409,
                y0: 455,
                x1: 528,
                y1: 485,
            },
            {
                x0: 0,
                y0: 455,
                x1: 319,
                y1: 485,
            },
            {
                x0: 0,
                y0: 30,
                x1: 30,
                y1: 455,
            },

            {
                x0: 30,
                y0: 263,
                x1: 123,
                y1: 293,
            },
            {
                x0: 94,
                y0: 123,
                x1: 123,
                y1: 263,
            },
            {
                x0: 94,
                y0: 93,
                x1: 434,
                y1: 123,
            },
            {
                x0: 404,
                y0: 123,
                x1: 434,
                y1: 270,
            },

            {
                x0: 108,
                y0: 358,
                x1: 219,
                y1: 388,
            },
            {
                x0: 189,
                y0: 202,
                x1: 219,
                y1: 358,
            },
            {
                x0: 189,
                y0: 172,
                x1: 326,
                y1: 202,
            },
            {
                x0: 296,
                y0: 202,
                x1: 326,
                y1: 339,
            },
            {
                x0: 296,
                y0: 339,
                x1: 498,
                y1: 369,
            },
        ],
    },
};
